/**
 * Direction provider (ADR-0012).
 *
 * Locale has three observable consequences — `<html lang>`, `<html dir>` and the i18next language — and they must
 * never disagree, or the interface ends up half-mirrored. This provider owns two of them (i18next is switched by
 * `useLocale`), and it runs before any page renders so the first paint is already right-to-left.
 */

import { useEffect } from 'react';

import { applyDocumentLocale } from '@/lib/i18n';
import { useUiStore } from '@/stores/uiStore';

/** Props accepted by {@link DirectionProvider}. */
export interface DirectionProviderProps {
  /** Subtree that renders inside the direction. */
  children: React.ReactNode;
}

/** Keeps `dir` and `lang` in step with the active locale. */
export function DirectionProvider({ children }: DirectionProviderProps) {
  const locale = useUiStore((state) => state.locale);

  useEffect(() => {
    applyDocumentLocale(locale);
  }, [locale]);

  return <>{children}</>;
}
